import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { CumuloRepository } from '../../../domain/repositories/cumulo/cumulo.repository';
import { CumuloValidationInput, CumuloValidationResult } from '../../../domain/interfaces/cumulo/cumulo.interface';
import { HttpClientService } from '../../services/http-client/http-client.service';
import { API_ENDPOINTS } from '../../config/api.config';

interface CumuloRequestDto {
  leadId: string;
  productFamily: string;
  placa: string;
}

interface CumuloInsuredItemDto {
  isItemCumulo: boolean;
  placa: string;
}

interface CumuloResponseDto {
  updateStatus: string | null;
  leadId: string;
  message: string;
  data: { insured_items: CumuloInsuredItemDto[] };
  productFamily: string;
}

@Injectable()
export class CumuloRepositoryImplementation extends CumuloRepository {
  private readonly http = inject(HttpClientService);

  override validate(input: CumuloValidationInput): Observable<CumuloValidationResult> {
    const dto: CumuloRequestDto = {
      leadId: input.leadId,
      productFamily: input.productFamily,
      placa: input.placa,
    };

    return this.http
      .postRaw<CumuloResponseDto>(API_ENDPOINTS.cumulo.validate, dto)
      .pipe(map((response) => this.toResult(response)));
  }

  private toResult(dto: CumuloResponseDto): CumuloValidationResult {
    return {
      updateStatus: dto.updateStatus,
      leadId: dto.leadId,
      message: dto.message,
      insuredItems: dto.data.insured_items.map((item) => ({
        isItemCumulo: item.isItemCumulo,
        placa: item.placa,
      })),
      productFamily: dto.productFamily,
    };
  }
}
